<template>
  <router-view />

  <offline-banner />
</template>

<script setup>
import { onMounted } from 'vue'
import { useAuth } from 'src/composables/app/useAuth'
import { usePageMetadata } from 'src/composables/app/usePageMetadata'

import OfflineBanner from 'src/components/common/OfflineBanner.vue'

const { initializeFromStorage } = useAuth()

// Initialize page metadata
usePageMetadata()

onMounted(async () => {
  await initializeFromStorage()
})
</script>
